import React, { useState, useEffect, useRef } from 'react';
import {useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
// import RequestTalkToaster from "../Toaster/RequestTalkToaster";
import ReactionsMenu from './ReactionsMenu';
import RequestToTalkDialog from './RequestToTalkDialog';
import ViewContextMenu from './ViewContextMenu';
import { ReactComponent as IconSetting } from "../../images/svg/gear.svg";
import { ReactComponent as IconView } from "../../images/svg/tiles-view.svg";
import { ReactComponent as IconMore } from "../../images/svg/more-action.svg";
import { ReactComponent as IconAudio } from "../../images/svg/microphone-slash.svg";
import { ReactComponent as IconArrowUp } from "../../images/svg/arrow-up.svg";
import { ReactComponent as IconVideo } from "../../images/svg/camera-disabled.svg";
import { ReactComponent as IconShare } from "../../images/svg/share-screen.svg";
import { ReactComponent as IconReaction } from "../../images/svg/face-smile.svg";
import { ReactComponent as IconRaiseHand } from "../../images/svg/raised-hand.svg";
import { ReactComponent as IconChat } from "../../images/svg/chat.svg";
import { ReactComponent as IconParticipant } from "../../images/svg/participant.svg";
import { ReactComponent as IconHangup } from "../../images/svg/hangup.svg";
import SettingsDialog from './SettingsDialog';

 const Toolbox = ({ 
    stompClient,
    userId,
    localUsername,
    roomName,
    meetingInfo,
    onHangup,
    onParticipantClick,
    onChatButtonClick,
    newMessageCounter,
    chatPanel,
    participantPanel,
    onUpdateUsername,
    getAvatarColor,
    overlay,
    isVisible
}) => {  
        
    const [requestTalkNotificationShow, setRequestTalkNotificationShow] = useState(false);
    const [requestTalkDialogShow, setRequestTalkDialogShow] = useState(false);
    const guests = useSelector(state => state.participants.guests);
    const hosts = useSelector(state => state.participants.hosts);
    const presenters = useSelector(state => state.participants.presenters);
    const [showReactionPanel, setShowReactionPanel] = useState(false);
    const disableReactions = useSelector(state => state.participants?.disableReactions ?? false);
    const [viewContextMenuOpen, setViewContextMenuOpen] = useState(false);
    const reactionMenuRef = useRef(null);
    const viewMenuRef = useRef(null);
    const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (reactionMenuRef.current && !reactionMenuRef.current.contains(event.target)) {
                setShowReactionPanel(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const requestTalk = () => {
        setRequestTalkNotificationShow(true);


        // setRequestTalkButtonDisabled(true);

        setTimeout(() => {
            setRequestTalkNotificationShow(false);
        }, 30000);

        if (stompClient) {
            const chatMessage = {
                sender: userId,
                name: localUsername,
                content: '',
                type: "WANT_TO_TALK",
                room: roomName,
            };
            stompClient.send("/app/chat.want.to.talk", {}, JSON.stringify(chatMessage));
        }
    }

    const handleRequestTalkDialog = (e) => {
        e.stopPropagation();
        setRequestTalkDialogShow(prevState => !prevState);
    }

    const handleViewContextMenu = (e) => {
        e.stopPropagation();
        setViewContextMenuOpen(prevState => !prevState);
    }


    const handleEmojiClick = (emoji) => {
        setShowReactionPanel(true);
        if (stompClient) {
            const chatMessage = {
                messageId: `${userId}-${Date.now().toString(36)}-${uuidv4()}`,
                sender: userId,
                name: localUsername,
                content: emoji,
                timestamp: new Date().toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true
                }),
                parentMessageId: null,
                type: "CHAT",
                room: roomName,
            };
            stompClient.send("/app/chat.send", {}, JSON.stringify(chatMessage));
        }
    };

    const participantCount = Object.entries(guests).length + Object.entries(hosts).length + Object.entries(presenters).length;


    return (
        <>

    <div className={`new-toolbox ${isVisible ? 'visible' : ''}`} style={{ width: participantPanel || chatPanel ? "calc(100% - 315px)" : "100%" }}>
        <div className="toolbox-content">
            <div className="toolbox-content-wrapper">
                <div className="toolbox-content-items">
                    
                    {overlay && (<div className="toolbox-overlay"></div>)}

                    <div className="context-menu context-menu-settings ">
                        <div className="toolbox-button" onClick={() => setSettingsDialogOpen(true)}>
                            <div className="toolbox-icon">
                                <IconSetting />
                            </div>
                            <span className="toolbox-button-label">Settings</span>
                        </div>
                    </div>

                    <div className="context-menu context-menu-tileview">
                        <div 
                            className="toolbox-button" 
                            onClick={handleViewContextMenu}
                        >
                            <div className="toolbox-icon">
                                <IconView />
                            </div>
                            <span className="toolbox-button-label">View</span>
                        </div>
                        <ViewContextMenu 
                            isOpen={viewContextMenuOpen} 
                            onClose={() => setViewContextMenuOpen(false)}
                        />
                    </div>

                    <div className="context-menu context-menu-overflow context-menu-disabled">
                        <div className="toolbox-button">
                            <div className="toolbox-icon">
                                <IconMore />
                            </div>
                            <span className="toolbox-button-label">More</span>
                        </div>
                        <div className="toolbox-tooltip">Menu disabled by host</div>
                    </div>

                    <div className="audio-preview context-menu">
                        <div className={`settings-button-container ${requestTalkDialogShow ? 'settings-button-container-open' : ''}`}>
                            <div className="toolbox-button" onClick={handleRequestTalkDialog}>
                                <div className="toolbox-icon">
                                    <IconAudio />
                                </div>
                                <span className="toolbox-button-label">Audio</span>
                            </div>
                            <span className="settings-button-small-icon">
                                <IconArrowUp />
                            </span>
                        </div>
                        <RequestToTalkDialog 
                                isOpen={requestTalkDialogShow} 
                                onConfirm={() => {
                                    requestTalk();
                                }} 
                                onCancel={() => setRequestTalkDialogShow(false)} 
                                requestTalkNotificationShow={requestTalkNotificationShow}
                            />
                    </div>

                    <div className="video-preview context-menu context-menu-disabled">
                        <div className="settings-button-container">
                            <div className="toolbox-button">
                                <div className="toolbox-icon">
                                    <IconVideo />
                                </div>
                                <span className="toolbox-button-label">Video</span>
                            </div>
                            <span className="settings-button-small-icon">
                                <IconArrowUp />
                            </span>
                        </div>
                        <div className="toolbox-tooltip">Video disabled by host</div>
                    </div>

                    <div className="context-menu context-menu-share-desktop context-menu-disabled">
                        <div className="toolbox-button">
                            <div className="toolbox-icon">
                                <IconShare />
                            </div>
                            <span className="toolbox-button-label">Share</span>
                        </div>
                        <div className="toolbox-tooltip">Screen sharing disabled by host</div>
                    </div>

                    <div className={`${(disableReactions ?? false) ? 'context-menu-disabled' : ''} context-menu context-menu-reactions`} ref={reactionMenuRef}>
                        <div className="toolbox-button" onClick={() => setShowReactionPanel(!showReactionPanel)}>
                            <div className="toolbox-icon">
                                <IconReaction />
                            </div>
                            <span className="toolbox-button-label">React</span>
                        </div>

                        {(disableReactions ?? false) && <div className="toolbox-tooltip">Reaction disabled by host</div>}

                        {showReactionPanel && !(disableReactions ?? false) && (
                            <ReactionsMenu handleEmojiClick={handleEmojiClick} />
                        )}
                    </div>

                    <div className="context-menu context-menu-raise-hand context-menu-disabled">
                        <div className="toolbox-button">
                            <div className="toolbox-icon">
                                <IconRaiseHand />
                            </div>
                            <span className="toolbox-button-label">Raise</span>
                        </div>
                        <div className="toolbox-tooltip">Raise hand disabled by host</div>
                    </div>

                    <div className="context-menu context-menu-chat" onClick={onChatButtonClick}>
                        <div className="toolbox-button">
                            <div className="toolbox-icon">
                                <IconChat />
                            </div>
                            <span className="toolbox-button-label">Chat</span>
                        </div>
                        { newMessageCounter > 0 ?
                        <span className="toolbox-badge">
                            {newMessageCounter}
                        </span> : null}
                    </div>

                    <div className="context-menu context-menu-participants" onClick={onParticipantClick}>
                        <div className="toolbox-button">
                            <div className="toolbox-icon">
                                <IconParticipant />
                            </div>
                            <span className="toolbox-button-label">People</span>
                        </div>    
                        <span className="toolbox-badge">
                            {participantCount}
                        </span>
                    </div>

                    <div className="context-menu context-menu-leave" onClick={onHangup}>
                        <div className="toolbox-button">
                            <div className="toolbox-icon">
                                <IconHangup />
                            </div>
                            <span className="toolbox-button-label">Leave</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>  
    </div>

    <SettingsDialog 
        isOpen={settingsDialogOpen}
        onClose={() => setSettingsDialogOpen(false)}
        localUsername={localUsername}
        onUpdateUsername={onUpdateUsername}
        getAvatarColor={getAvatarColor}
    />

    </>
    )
}

export default Toolbox;